import { render, staticRenderFns } from "./BankDetailsInput.vue?vue&type=template&id=40f49392&"
import script from "./BankDetailsInput.vue?vue&type=script&lang=js&"
export * from "./BankDetailsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BankDetailsInput.vue"
export default component.exports